var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoLicenseData = function SvgNoLicenseData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 112
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M72.966 25.156h-30.97a2.66 2.66 0 0 0-2.662 2.654v68.624l-.355.108-7.598 2.32a1.423 1.423 0 0 1-1.773-.94L7.01 24.326a1.416 1.416 0 0 1 .943-1.768l11.707-3.574L53.6 8.626l11.708-3.574a1.415 1.415 0 0 1 1.773.938l5.776 18.812.109.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M79.724 24.802 72.762 2.129a3.008 3.008 0 0 0-1.47-1.776 3.027 3.027 0 0 0-2.298-.22l-16.46 5.024-33.94 10.36-16.46 5.024a3.01 3.01 0 0 0-2.002 3.756l23.795 77.486a3.021 3.021 0 0 0 3.768 1.995l11.284-3.443.355-.11v-.37l-.355.109-11.389 3.477a2.666 2.666 0 0 1-3.324-1.761L.473 24.193a2.652 2.652 0 0 1 1.766-3.314l16.46-5.025L52.64 5.496 69.098.471a2.662 2.662 0 0 1 3.324 1.761l6.93 22.57.11.354h.37l-.11-.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M21.772 22.616a1.598 1.598 0 0 1-1.528-1.126l-2.286-7.444a1.59 1.59 0 0 1 1.06-1.989l31.223-9.53a1.598 1.598 0 0 1 1.995 1.056l2.286 7.444c.257.84-.217 1.73-1.06 1.989l-31.223 9.53c-.151.046-.309.07-.467.07z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.746,
    cy: 4.415,
    fill: "#37A3BC",
    rx: 3.549,
    ry: 3.539
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.746,
    cy: 4.415,
    fill: "#FFF",
    rx: 2.248,
    ry: 2.241
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M106.95 103.007H46.964a1.508 1.508 0 0 1-1.509-1.504V29.844a1.508 1.508 0 0 1 1.509-1.504h59.984a1.508 1.508 0 0 1 1.509 1.504v71.66a1.508 1.508 0 0 1-1.509 1.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M79.353 24.802H41.996a3.015 3.015 0 0 0-3.017 3.008v72.154l.355-.108V27.81a2.66 2.66 0 0 1 2.662-2.654h37.467l-.11-.354zm32.565 0H41.996a3.015 3.015 0 0 0-3.017 3.008v81.036a3.017 3.017 0 0 0 3.017 3.008h69.922a3.017 3.017 0 0 0 3.017-3.008V27.81a3.016 3.016 0 0 0-3.017-3.008zm2.663 84.044a2.662 2.662 0 0 1-2.663 2.654H41.996a2.661 2.661 0 0 1-2.662-2.654V27.81a2.66 2.66 0 0 1 2.662-2.654h69.922a2.662 2.662 0 0 1 2.663 2.654v81.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M93.284 32.587H60.63a1.597 1.597 0 0 1-1.597-1.593V23.21c0-.879.715-1.591 1.597-1.592h32.654c.882 0 1.596.713 1.597 1.592v7.785c0 .88-.715 1.592-1.597 1.593z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.957,
    cy: 18.609,
    fill: "#37A3BC",
    rx: 3.549,
    ry: 3.539
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.957,
    cy: 18.609,
    fill: "#FFF",
    rx: 2.162,
    ry: 2.155
  }))));
};
export default SvgNoLicenseData;